// Rótulo legível da origem (`leads.source`). Antes duplicado em LeadDetail e
// Analytics com textos diferentes; a tabela de Leads & propostas também usa.
// `prospeccao` = lead frio movido para o funil (flows/prospeccao.md).
export const LEAD_SOURCE_LABELS: Readonly<Record<string, string>> = {
  contact_form: "Formulário do site",
  landing_automacao_empresarial: "Landing Automação",
  automacao_cta: "CTA Automação",
  whatsapp: "WhatsApp",
  email: "E-mail",
  direct: "Direto",
  manual: "Manual (Admin)",
  admin_manual: "Manual (Admin)",
  indicacao: "Indicação",
  referral: "Indicação",
  instagram: "Instagram",
  linkedin: "LinkedIn",
  google: "Google",
  prospeccao: "Lead frio",
};

/** Origem desconhecida aparece crua (vem da API/MCP); vazia vira "—". */
export function leadSourceLabel(source: string | null | undefined): string {
  if (!source) return "—";
  return LEAD_SOURCE_LABELS[source] ?? source;
}
